module.exports = __webpack_public_path__ + "static/helpthem-18d5ae1f641e92a3bf40d61309553bee.png";